module.exports = __webpack_public_path__ + "img/HY3702-177.eb640e4d.jpg";